<template>
  <div class="home">
    <section class="home__header">
      <div class="home__header-inner">
        <h1 class="home__title">Carreras</h1>
        <p class="home__subtitle">Consulta los resultados en tiempo real</p>
        <div class="home__search">
          <font-awesome-icon icon="search" class="home__search-icon" />
          <input
            type="search"
            class="home__search-input"
            placeholder="Buscar carrera por nombre…"
            aria-label="Buscar carrera"
            v-model="carreraSearch"
            v-on:change="carreraFilter"
          />
        </div>
      </div>
    </section>

    <section class="home__content">
      <div class="table-card">
        <b-table
          hover
          id="carreras-table"
          :items="carreras"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          @row-clicked="carreraSelected"
          thead-class="modern-thead"
          :filter="carreraCriteria"
          :filter-function="filterTable"
          :responsive="true"
          borderless
          small
        >
          <template #head(Nombre)>
            <span class="modern-th modern-th--left">Carrera</span>
          </template>

          <template #head(Fecha)>
            <span class="modern-th">Fecha</span>
          </template>

          <template #head(Tipo)>
            <span class="modern-th">Tipo</span>
          </template>

          <template #head(Estado)>
            <span class="modern-th">Estado</span>
          </template>

          <template #cell(Nombre)="data">
            <div class="cell-nombre">{{data.value}}</div>
          </template>

          <template #cell(Fecha)="data">
            <div class="cell-fecha">{{data.value.split(" ")[0]}}</div>
          </template>

          <template #cell(Tipo)="data">
            <div class="cell-tipo">
              <font-awesome-icon
                v-if="tipoIcon(data.value)"
                :icon="tipoIcon(data.value)"
                class="cell-tipo__icon"
                aria-hidden="true"
              />
              <span>{{data.value}}</span>
            </div>
          </template>

          <template #cell(Estado)="data">
            <div class="cell-estado">
              <span class="status-badge" :class="statusClass(data.value)">
                <span class="status-badge__dot"></span>
                {{data.value}}
              </span>
            </div>
          </template>
        </b-table>
      </div>

      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="carreras-table"
        align="center"
        class="home__pagination"
      ></b-pagination>
    </section>

    <b-modal
      v-model="showWelcomeModal"
      centered
      hide-footer
      hide-header
      no-close-on-esc
      no-close-on-backdrop
      modal-class="welcome-modal"
      size="md"
    >
      <div class="welcome-modal__content">
        <div class="welcome-modal__badge" aria-hidden="true">
          <font-awesome-icon icon="trophy" class="welcome-modal__badge-icon" />
        </div>
        <h3 class="welcome-modal__title">¡Tenemos una nueva versión!</h3>
        <p class="welcome-modal__text">
          Hemos lanzado una versión renovada de <strong>Cronomancha</strong>:
          más rápida, con mejor diseño y pensada para móvil.
        </p>
        <p class="welcome-modal__question">¿Quieres probarla?</p>
        <div class="welcome-modal__actions">
          <b-button class="welcome-modal__btn welcome-modal__btn--secondary" @click="stayOnLegacy">
            Seguir aquí
          </b-button>
          <b-button class="welcome-modal__btn welcome-modal__btn--primary" @click="goToNewVersion">
            Ir a la nueva versión
          </b-button>
        </div>
        <b-form-checkbox v-model="dontShowWelcomeAgain" class="welcome-modal__checkbox">
          No volver a mostrar
        </b-form-checkbox>
      </div>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import JSZip from 'jszip';

const WELCOME_MODAL_KEY = 'cronomancha:welcomeModalSeen';
const NEW_VERSION_URL = 'https://resultados-app.cronomancha.com';

export default {
  name: 'Home',
  components: {

  },
  data() {
    return {
      perPage: 20,
      currentPage: 1,
      sortBy: 'Fecha',
      sortDesc: false,
      criteriaFilter: '',
      carreraCriteria: '',
      // fields: ['Nombre', 'Estado', 'Edición', 'Fecha', 'Distancia', 'Tipo'],
      fields: [
        {key:'Nombre', isRowHeader: true},
        {key:'Fecha', isRowHeader: true},
        {key:'Estado', isRowHeader: true},
        {key:'Tipo', isRowHeader:true}
      ],
      carreras: [

      ],
      carrerasInfo: [],
      carreraSearch: '',
      showWelcomeModal: false,
      dontShowWelcomeAgain: false,
    }
  },
  methods: {

    /**Obtenemos el listado de todas las carreras disponibles */
    getCarreras: function(){
      console.log("Se están consultando las carreras");
      axios.get("/data/index.php", {
        headers: {
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then( result =>{
        let $vm = this;
        $vm.carrerasInfo = result.data;
        // console.log($vm.carrerasInfo);
        console.log("Se recibió la información del servidor");
        $vm.carrerasInfo.forEach( element=> {
          let kms = parseInt( element.DistanciaMetrosTotalT01 )/1000.0;
          let fechaDeCarrera;

          if("FechaCarreraT01" in element){
            fechaDeCarrera = element.FechaCarreraT01;
          }
          else if("DiaHoraInicioT01" in element){
            fechaDeCarrera = element.DiaHoraInicioT01;
          }

          $vm.carreras.push({Nombre: element.NombreCarreraT01,
            Estado: element.EstadoCarrera,
            Edicion: element.EdicionCarreraT01,
            // Fecha: element.DiaHoraInicioT01,
            // Fecha: element.Fecha,
            Fecha: fechaDeCarrera,
            Distancia: kms + 'kms',
            'Tipo': element.Modalidad,
            TS: element.TS,
            dir: element.dir })
          // console.log(element.NombreCarreraT01)
        })

        $vm.carreras.sort(function(a,b){
          // let date1 = new Date( parseInt(a.TS) );
          // let date2 = new Date( parseInt(b.TS) );

          let splittedDateA = a.Fecha.split(' ');
          let splittedDateB = b.Fecha.split(' ');

          let originalDateA = splittedDateA[0];
          let originalDateB = splittedDateB[0];

          let splittedA = originalDateA.split('/');
          let splittedB = originalDateB.split('/');

          let yearA = splittedA[2];
          let yearB = splittedB[2];

          let monthA = splittedA[1];
          let monthB = splittedB[1];

          let dayA = splittedA[0];
          let dayB = splittedB[0];

          let formatedA = yearA + '/' + monthA + '/' + dayA + ' ' + splittedDateA[1];

          let formatedB = yearB + '/' + monthB + '/' + dayB + ' ' + splittedDateB[1];

          let date1 = Date.parse(formatedA);
          let date2 = Date.parse(formatedB);

          if(isNaN(date1) ){
            // console.log("Es un NaN");
            date1 = 0;
          }
          if(isNaN(date2)){
            // console.log("Es un NaN");
            date2 = 0;
          }

          if(date1 < date2){
            return 1;
          }
          if(date1 > date2){
            return -1;
          }
          return 0;
        });

        // console.log($vm.carreras);
      })
      .catch( err =>{
        console.log(err);
      })
    },
    carreraSelected: function(record, index){
      let $vm = this;
      console.log(record);
      console.log(index);
      // $vm.getCarrera(record.dir, record.TS)
      let distancia = record.Distancia.split('kms');

      distancia = parseInt(distancia[0]);
      console.log(distancia);
      $vm.$store.commit('change', record.Nombre);
      $vm.$store.commit('changeDistancia', distancia);
      $vm.$router.push('/carrera/' + record.dir);
    },
    filterTable: function(row){
      let $vm = this;
      // console.log($vm.carreraCriteria);
      if(row.Nombre.includes($vm.carreraCriteria)){
        return true;
      }
      else{
        return false;
      }
    },
    carreraFilter(){
      let $vm = this;
      $vm.carreraCriteria = $vm.carreraSearch.toUpperCase();
      console.log($vm.carreraCriteria);
    },
    tipoIcon(tipo){
      if(!tipo) return null;
      const t = tipo.toString().toLowerCase();
      if(t.includes('bici') || t.includes('bike') || t.includes('ciclis')) return 'biking';
      if(t.includes('pie') || t.includes('run') || t.includes('correr') || t.includes('camin')) return 'running';
      return null;
    },
    statusClass(estado){
      if(!estado) return 'status-badge--upcoming';
      const e = estado.toString().toLowerCase();
      if(e.includes('corriendo')) return 'status-badge--running';
      if(e.includes('finaliz')) return 'status-badge--finished';
      return 'status-badge--upcoming';
    },
    stayOnLegacy(){
      if (this.dontShowWelcomeAgain) {
        window.localStorage.setItem(WELCOME_MODAL_KEY, '1');
      }
      this.showWelcomeModal = false;
    },
    goToNewVersion(){
      if (this.dontShowWelcomeAgain) {
        window.localStorage.setItem(WELCOME_MODAL_KEY, '1');
      }
      window.location.href = NEW_VERSION_URL;
    }
  },
  created(){
    let $vm = this;
    $vm.getCarreras();
    $vm.$store.commit('change', 'Sistema de resultados en tiempo real')
    if (window.localStorage.getItem(WELCOME_MODAL_KEY) !== '1') {
      $vm.showWelcomeModal = true;
    }
  },
  computed: {
    rows() {
        return this.carreras.length
      }
  }
}
</script>

<style scoped>
.home {
  width: 100%;
  padding: 0;
}

.home__header {
  background: linear-gradient(135deg, #ffffff 0%, #fef2f2 100%);
  padding: 2.5rem 1rem 2rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.04);
}
.home__header-inner {
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}
.home__title {
  font-size: 2rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.35rem;
  letter-spacing: -0.02em;
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
}
.home__subtitle {
  color: #64748b;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}
.home__search {
  position: relative;
  max-width: 520px;
  margin: 0 auto;
}
.home__search-icon {
  position: absolute;
  left: 1.1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 0.95rem;
  pointer-events: none;
}
.home__search-input {
  width: 100%;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #fff;
  border-radius: 999px;
  padding: 0.8rem 1.25rem 0.8rem 2.85rem;
  font-size: 0.95rem;
  color: #0f172a;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  outline: none;
}
.home__search-input::placeholder { color: #94a3b8; }
.home__search-input:focus {
  border-color: #f80606;
  box-shadow: 0 0 0 4px rgba(248, 6, 6, 0.12);
}

.home__content {
  max-width: 1100px;
  margin: 1.75rem auto 2rem;
  padding: 0 1rem;
}

.table-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.04);
}

.table-card ::v-deep table {
  margin-bottom: 0;
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
}

.table-card ::v-deep .modern-thead tr {
  background: #f8fafc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}
.table-card ::v-deep .modern-thead th {
  border: 0 !important;
  padding: 0.95rem 1rem;
  vertical-align: middle;
  background: transparent !important;
}

.modern-th {
  font-weight: 600;
  color: #64748b;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  display: block;
  text-align: center;
}
.modern-th--left { text-align: left; }

.table-card ::v-deep tbody tr {
  transition: background 0.12s ease;
  cursor: pointer;
}
.table-card ::v-deep tbody tr:hover {
  background: #fff8f8;
}
.table-card ::v-deep tbody td {
  padding: 1rem;
  vertical-align: middle;
  border-top: 1px solid rgba(15, 23, 42, 0.05);
  border-bottom: 0;
}
.table-card ::v-deep tbody tr:first-child td {
  border-top: 0;
}

.cell-nombre {
  font-weight: 600;
  color: #0f172a;
  font-size: 0.95rem;
  line-height: 1.3;
}
.cell-fecha {
  text-align: center;
  color: #64748b;
  font-size: 0.9rem;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.cell-tipo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  color: #475569;
  font-size: 0.9rem;
}
.cell-tipo__icon {
  color: #f80606;
  font-size: 0.95rem;
}
.cell-estado {
  display: flex;
  justify-content: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.3rem 0.8rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  white-space: nowrap;
}
.status-badge__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}
.status-badge--running {
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
}
.status-badge--running .status-badge__dot {
  animation: statusPulse 1.5s ease-in-out infinite;
}
.status-badge--finished {
  background: rgba(100, 116, 139, 0.12);
  color: #475569;
}
.status-badge--upcoming {
  background: rgba(59, 130, 246, 0.12);
  color: #2563eb;
}
@keyframes statusPulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.55; transform: scale(1.35); }
}
@media (prefers-reduced-motion: reduce) {
  .status-badge--running .status-badge__dot { animation: none; }
}

.home__pagination {
  margin-top: 1.5rem;
}
.home__pagination ::v-deep .page-item .page-link {
  color: #f80606;
  border-radius: 10px;
  margin: 0 2px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  font-weight: 500;
}
.home__pagination ::v-deep .page-item.active .page-link {
  background: #f80606;
  border-color: #f80606;
  color: #fff;
  box-shadow: 0 2px 8px rgba(248, 6, 6, 0.3);
}
.home__pagination ::v-deep .page-item.disabled .page-link {
  color: #cbd5e1;
}

/* Welcome modal */
::v-deep .welcome-modal .modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.25);
}
::v-deep .welcome-modal .modal-body {
  padding: 2.25rem 1.75rem 1.5rem;
}
.welcome-modal__content {
  text-align: center;
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
}
.welcome-modal__badge {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f80606, #b30505);
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 24px rgba(248, 6, 6, 0.35);
}
.welcome-modal__badge-icon {
  color: #fff;
  font-size: 1.65rem;
}
.welcome-modal__title {
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 0.75rem;
  font-size: 1.35rem;
  letter-spacing: -0.01em;
}
.welcome-modal__text {
  color: #475569;
  margin-bottom: 0.35rem;
  font-size: 0.95rem;
  line-height: 1.45;
}
.welcome-modal__question {
  font-weight: 700;
  color: #0f172a;
  margin: 0.75rem 0 1.25rem;
}
.welcome-modal__actions {
  display: flex;
  justify-content: center;
  gap: 0.6rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
.welcome-modal__btn {
  border-radius: 10px;
  padding: 0.6rem 1.2rem;
  font-weight: 600;
  border: 0;
  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
  min-width: 140px;
}
.welcome-modal__btn--secondary {
  background: #f1f5f9;
  color: #475569;
}
.welcome-modal__btn--secondary:hover,
.welcome-modal__btn--secondary:focus,
.welcome-modal__btn--secondary:active {
  background: #e2e8f0 !important;
  color: #0f172a !important;
  border-color: transparent !important;
}
.welcome-modal__btn--primary {
  background: #f80606;
  color: #fff;
  box-shadow: 0 3px 10px rgba(248, 6, 6, 0.3);
}
.welcome-modal__btn--primary:hover,
.welcome-modal__btn--primary:focus,
.welcome-modal__btn--primary:active {
  background: #d40505 !important;
  border-color: #d40505 !important;
  box-shadow: 0 6px 16px rgba(248, 6, 6, 0.4);
  transform: translateY(-1px);
}
.welcome-modal__checkbox ::v-deep .custom-control-label {
  color: #94a3b8;
  font-size: 0.85rem;
}

@media (max-width: 575px) {
  .home__header { padding: 2rem 1rem 1.5rem; }
  .home__title { font-size: 1.55rem; }
  .home__subtitle { font-size: 0.85rem; margin-bottom: 1rem; }
  .home__search-input { font-size: 0.9rem; padding: 0.7rem 1rem 0.7rem 2.6rem; }
  .home__content { margin: 1.25rem auto 1.5rem; padding: 0 0.6rem; }
  .table-card { border-radius: 12px; }
  .table-card ::v-deep tbody td { padding: 0.75rem 0.55rem; }
  .table-card ::v-deep .modern-thead th { padding: 0.75rem 0.55rem; }
  .cell-nombre { font-size: 0.88rem; }
  .cell-fecha { font-size: 0.82rem; }
  .cell-tipo { font-size: 0.82rem; }
  .status-badge { font-size: 0.7rem; padding: 0.25rem 0.6rem; }
  .welcome-modal__btn { min-width: 0; flex: 1 1 auto; }
}
</style>
